<template>
  <v-container fluid>
    <v-container fluid class="app-container">
      <router-view></router-view>
    </v-container>
    <px-verifier-dialog ref="verifier" />
  </v-container>
</template>

<script>
import UserService from '@/api/user-service';
import VerifierDialog from './VerifierDialog.vue';

export default {
  methods: {
    verifyUser() {
      UserService.hasFornecedor()
        .then(({ data }) => {
          if (data.hasAccess) {
            return;
          }
          this.$refs.verifier.open();
        });
    },
  },
  created() {
    this.verifyUser();
  },
  components: {
    pxVerifierDialog: VerifierDialog,
  },
};
</script>
